import { FormWithRedux } from '../../FormWithRedux';

export class GPChestPainAbnormalitiesForm extends FormWithRedux {

    constructor(formIdentifier, parent, actionUpdater, dependentValuesUpdater, calculationsUpdater) {
        super(formIdentifier, parent, actionUpdater, dependentValuesUpdater, calculationsUpdater);
    }

    shouldDisplayFormDetailForIdentifier(identifier) {
        super.shouldDisplayFormDetailForIdentifier(identifier);
        if (identifier === 'alternativeFindingSpecify') {
            let alternativeFinding = this.getValue('alternativeFinding');
            return alternativeFinding == null ? true : alternativeFinding;
        } else if( identifier == 'noToAllOtherAbnormalities'){
            return this.unselectedExplicitFormDetailsCount(identifier) > 1;
        }

        return true;
    }

    isEnabled(identifier) {
        if (identifier != null) {
            return true;
        }
        return false;
    }

    isMandatory(identifier) {
        if(identifier == 'alternativeFindingSpecify'){
            let alternativeFinding = this.getValue('alternativeFinding');
            return alternativeFinding == null ? false : alternativeFinding;
        } else if (identifier == 'noToAllOtherAbnormalities') {
            return false;
        } else {
            let values = [this.getValue('newIschaemia'),
                this.getValue('oldIschaemia'),
                this.getValue('oldLBBB'),
                this.getValue('nonSpecificSTorTChanges'),
                this.getValue('alternativeFinding')];

            if(values.includes(true) || values.includes(false)){
                return true;
            }

            let dependantValue = this.getValue('abnormalitiesPresent');
            return dependantValue == null ? false : dependantValue;
        }
    }

    getValueType() {
        return 'boolean';
    }

    submissionValidation() {
        return [];
    }

    detailString(isSubform) {
        let formDetails = this.getFormDetails();
        let values = formDetails.map((value) => {
            return value.valueDescription() == null || value.valueDescription() == false  ? null : (isSubform ? '- ' : '') + value.valueDescription();
        });

        if(values.filter(n => n).length == 0){
            return this.detail;
        }

        return values.filter(n => n).join(',\n');
    }

}


// WEBPACK FOOTER //
// ./src/forms/gpChestPain01/Forms/GPChestPain-AbnormalitiesForm.js